import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ChatbotSolutionSupport,
  ChatbotSolutionSecure,
  ChatbotSolutionAccurate,
  ChatbotSolutionIntent,
  ChatbotSolutionConversational,
  ChatbotSolutionOmni,
} from "../../../app-constants";

function Nftproficient() {
  return (
    <section className="nft_proficient chatbot_capabilities p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Tekrevol’s Chatbot Development Solutions: Six Exceptional Chatbot
              Capabilities
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{ChatbotSolutionSupport}</div>
                  <div className="nft_prof_content">
                    <h5>Multilingual Support</h5>
                    <p>
                      Our chatbot development solutions leverage NLP to curate
                      multilingual responses. Whether your customers are in your
                      home country, or anywhere across the globe, your chatbot
                      will easily manage communication. Even if English is not
                      their first language, the chatbots can adapt to a simpler
                      tone, and style of conversation.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{ChatbotSolutionSecure}</div>
                  <div className="nft_prof_content">
                    <h5>Highly-Secure Communication</h5>
                    <p>
                      Our chatbot developers assure that the virtual bots we
                      provide are protected by enterprise-level security. These
                      bots can converse with the customer in a safe and secure
                      manner, thus making them a solid option for deployment
                      across financial platforms, retail, and e-commerce.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{ChatbotSolutionAccurate}</div>
                  <div className="nft_prof_content">
                    <h5>Accurate Sentiment Analysis</h5>
                    <p>
                      Being a dedicated AI chatbot development company, we have
                      leveraged NLP to equip our chatbots with the skills to
                      perform deep sentiment analysis with astounding level of
                      accuracy. They understand attitudes, and emotions of
                      humans, and prepare natural, and appropriate responses in
                      no time.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{ChatbotSolutionIntent}</div>
                  <div className="nft_prof_content">
                    <h5>Intent-focused Delivery</h5>
                    <p>
                      Our chatbot services hinge on leveraging NLP technology to
                      its fullest. Beyond understanding simple language, these
                      AI chatbots can even examine intent of the user, and
                      prepare answers accordingly. They can add more context to
                      your queries by offering a variety of options, thus
                      helping you to broaden your search. Plus, they can also
                      offer precisely accurate responses to save time, and
                      enhance effectiveness of research work.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">
                    {ChatbotSolutionConversational}
                  </div>
                  <div className="nft_prof_content">
                    <h5>Conversational</h5>
                    <p>
                      Chatbots pivot the NLP techniques to make sense of the
                      intent of the user. These bots are specially designed to
                      be as conversational as possible. They can easily adapt to
                      the required tone, and style without further instruction.
                      From simple greetings to instructing customers, and even
                      helping them resolve complaints, our AI chatbot services
                      ensure you get the best information for your input.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_prof_box">
                  <div className="nft_prof_svg">{ChatbotSolutionOmni}</div>
                  <div className="nft_prof_content">
                    <h5>Omni-platform Support</h5>
                    <p>
                      What makes our chatbot development solutions a true
                      standout from the rest is the omni-platform integration.
                      Chatbots can easily integrate with other platforms or
                      websites, or even the favorite social media of your
                      audience. You don’t need to invest heavily on the pull
                      strategy to attract more visitors. You can simply
                      integrate chatbots with the favorite messaging apps of
                      your audience.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftproficient;
